import { storyblokInit } from 'gatsby-source-storyblok';
import configuration from '../../../gatsby-config';
import {
  BlockGroup,
  BlogGridTiles,
  CardsSection,
  ChecklistBox,
  CompanyFacts,
  ContactForm,
  ContactFormComponent,
  FullWidthSlider,
  FullWidthSliderContent,
  Headlines,
  Hero,
  HistorySection,
  ImagesSlideshow,
  JobPositions,
  JobRow,
  JobTags,
  LaunchplanForm,
  LinkList,
  MapsSection,
  MeetTeammember,
  PartnerLogos,
  Person,
  Persons,
  Perks,
  ProvenexpertForm,
  ReferencesTiles,
  RichTextSection,
  Richtext,
  ScrollSlider,
  ScrollSliderItem,
  ServiceStepRows,
  ServiceSteps,
  ServicesTiles,
  SpacerNew,
  SpecialistForm,
  TestimonialCards,
  TestimonialCardsContent,
  TextWithImageSection,
  TextWrapper,
  UseCasesTiles,
  VerticalSlider,
  VerticalTestimonials,
  OurServices,
  BlogPostMediaVideo,
  BlogGridView,
  ImageSlider,
  CtaButton,
  Success,
  Button,
} from './index';

const sbConfig = configuration.plugins.find((item) => item.resolve === 'gatsby-source-storyblok');

(() => {
  storyblokInit({
    accessToken: sbConfig.options.accessToken,
    cache: {
      clear: 'auto',
      type: 'memory',
    },
    resolveRelations: [
      'blogpost.author',
      'page.jobs',
      'job-positions.jobs',
      'references-tiles.tile',
      'use-cases-tiles.use_case',
      'services-tiles.services',
      'service.icon',
      'perk.icon',
      'perks.icon',
      'navigation.Menu',
      'page.Icon',
      'blog-grid-view.posts',
    ],
    components: {
      hero: Hero,
      'company-facts': CompanyFacts,
      'block-group': BlockGroup,
      'rich-text': Richtext,
      headlines: Headlines,
      'checklist-box': ChecklistBox,
      'contact-form': ContactForm,
      'contact-form-component': ContactFormComponent,
      persons: Persons,
      person: Person,
      'rich-text-section': RichTextSection,
      'image-with-text': TextWithImageSection,
      'images-slideshow': ImagesSlideshow,
      testimonials: VerticalTestimonials,
      perks: Perks,
      'job-positions': JobPositions,
      'references-tiles': ReferencesTiles,
      'use-cases-tiles': UseCasesTiles,
      'launchplan-form': LaunchplanForm,
      linklist: LinkList,
      'spacer-new': SpacerNew,
      'cards-section': CardsSection,
      history: HistorySection,
      'our-services': OurServices,
      'testimonials-section': TestimonialCards,
      'full-width-slider': FullWidthSlider,
      'partners-logos': PartnerLogos,
      'full-width-slider-content': FullWidthSliderContent,
      'testimonial-content': TestimonialCardsContent,
      'text-wrapper': TextWrapper,
      'services-steps-section': ServiceSteps,
      'service-steps': ServiceStepRows, // Single Service Step Colum
      'job-single-row': JobRow,
      'jobs-tags': JobTags,
      'vertical-slider': VerticalSlider,
      'services-tiles': ServicesTiles,
      'map-section': MapsSection,
      'blogpost-tiles-component': BlogGridTiles,
      'scroll-slider': ScrollSlider,
      'scroll-slider-item': ScrollSliderItem,
      'specialist-form': SpecialistForm,
      'blog-post-media-video': BlogPostMediaVideo,
      blogpost_tiles: BlogGridTiles,
      'blog-grid-view': BlogGridView,
      'image-slider': ImageSlider,
      'cta-button': CtaButton,
      'meet-teammember': MeetTeammember,
      'provenexpert-form': ProvenexpertForm,
      Success,
      button: Button,
    },
    localAssets: false,
  });
})();
